/* Cartwala draft theme — Start Design opens existing mug editor before product details. */
(function () {
  "use strict";
  if (window.__cwMugDirectFlow) return;
  window.__cwMugDirectFlow = true;
  var FLAG = "cw_start_design";
  var KEY = "cw_mug_start_return";
  var isProduct = /^\/products\/[^/]+/.test(location.pathname);
  var direct = isProduct && new URLSearchParams(location.search).get(FLAG) === "1";

  function isGalleryStart(anchor) {
    return anchor && anchor.matches("a.cw-mug-card__start[href]") &&
      !!anchor.closest(".cw-mug-gallery");
  }

  document.addEventListener("click", function (event) {
    var anchor = event.target && event.target.closest && event.target.closest("a.cw-mug-card__start");
    if (!isGalleryStart(anchor) || event.defaultPrevented ||
        event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target;
    try { target = new URL(anchor.href, location.href); } catch (err) { return; }
    if (target.origin !== location.origin || !/^\/products\//.test(target.pathname)) return;
    event.preventDefault();
    event.stopPropagation();
    try { sessionStorage.setItem(KEY, location.pathname + location.search + location.hash); } catch (e) {}
    target.searchParams.set(FLAG, "1");
    var currentPreview = new URLSearchParams(location.search).get("preview_theme_id");
    if (currentPreview && !target.searchParams.has("preview_theme_id")) {
      target.searchParams.set("preview_theme_id", currentPreview);
    }
    location.assign(target.href);
  }, true);

  if (!direct) return;

  function goBack() {
    var fallback = "/collections/customised-mugs";
    try {
      var previous = sessionStorage.getItem(KEY);
      if (previous && previous.startsWith("/") && !previous.startsWith("//")) fallback = previous;
    } catch (e) {}
    location.assign(fallback);
  }

  function makeCover() {
    var cover = document.createElement("div");
    cover.id = "cw-mug-design-cover";
    cover.innerHTML =
      '<div class="cw-mug-cover-box"><span class="cw-mug-cover-spinner" aria-hidden="true"></span>' +
      '<p data-cw-mug-cover-status>Opening your mug customizer…</p>' +
      '<button type="button" data-cw-mug-cancel>Back to mugs</button></div>';
    document.body.appendChild(cover);
    cover.querySelector("[data-cw-mug-cancel]").addEventListener("click", goBack);
    return cover;
  }

  function startDirect() {
    var cover = makeCover();
    var complete = false;
    var launched = false;
    var startAt = Date.now();
    var installed = false;
    var dialog;
    var root;
    var retry;

    function cleanup() {
      clearInterval(retry);
      document.documentElement.classList.remove("cw-mug-direct-pending");
      if (cover.isConnected) cover.remove();
    }
    function finish() {
      if (complete) return;
      complete = true;
      cleanup();
      var url = new URL(location.href);
      url.searchParams.delete(FLAG);
      history.replaceState(history.state, "", url.pathname + url.search + url.hash);
      window.scrollTo({top:0,behavior:"instant"});
      var preview = document.querySelector("[data-cw-mug-preview]:not([hidden])");
      if (preview) preview.scrollIntoView({block:"center",behavior:"auto"});
    }
    function saved(event) {
      if (!event.detail || !event.detail.url) return;
      complete = true;
      // Native Cartwala has set up its preview and submits the design for local
      // persistence. Wait for its dialog to close, then show the product page.
      if (dialog && !dialog.open) finishSaved();
    }
    function finishSaved() {
      // Keep successful completion separate from cancel handling.
      cleanup();
      var u = new URL(location.href);
      u.searchParams.delete(FLAG);
      history.replaceState(history.state, "", u.pathname + u.search + u.hash);
      window.scrollTo(0,0);
      var preview = document.querySelector("[data-cw-mug-preview]:not([hidden])");
      if (preview) preview.scrollIntoView({block:"center",behavior:"auto"});
    }
    function dialogClosed() {
      if (complete) { finishSaved(); return; }
      // A customer leaving the editor without saving returns to the mug designs.
      goBack();
    }
    function tryStart() {
      if (launched) return;
      if (!root) root = document.querySelector(
        '[data-cw-personalizer][data-product-kind="mug"],[data-cw-gift-personalizer][data-product-kind="mug"]'
      );
      if (root) {
        var opener = root.querySelector("[data-cw-open]");
        dialog = root.querySelector("[data-cw-dialog]");
        if (!installed && opener && dialog) {
          installed = true;
          root.addEventListener("cartwala:preview-ready", saved);
          dialog.addEventListener("close", dialogClosed);
        }
        if (opener && dialog && root.dataset.cwReady === "true") {
          // Allow the app to attach its native button listeners after setting cwReady.
          launched = true;
          clearInterval(retry);
          setTimeout(function () {
            if (!dialog.open) opener.click();
            if (!dialog.open) {
              try { dialog.showModal(); } catch (e) {}
            }
          }, 150);
          return;
        }
      }
      if (Date.now() - startAt > 25000) {
        clearInterval(retry);
        var status = cover.querySelector("[data-cw-mug-cover-status]");
        if (status) status.textContent =
          "The mug editor could not open. Please return to mugs and try again.";
        var spin = cover.querySelector(".cw-mug-cover-spinner");
        if (spin) spin.hidden = true;
      }
    }
    retry = setInterval(tryStart, 180);
    tryStart();
    window.addEventListener("pagehide", function () { clearInterval(retry); }, {once:true});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startDirect, {once:true});
  } else startDirect();
})();
